const es = global.es; // TODO: Remove dependency!

export default class ObjectUtil {

    /**
     * Gets a deep copy of json obj
     * 
     * warn: will remove and functions from object
     * 
     * Note on performance, see: TOR9-17949
     */
    deepCopy(obj: any): any {
        // Handle the 3 simple types, and null or undefined
        if (null == obj || "object" != typeof obj) {
            return obj;
        }
        
        // Handle Number
        if (obj instanceof Number) {
            return JSON.parse(JSON.stringify(obj)); // converts back to primitive type
        }
        
        // Handle Date
        if (obj instanceof Date) {
            const copy = new Date();
            copy.setTime(obj.getTime());
            return copy;
        }
        
        // Handle Array
        if (obj instanceof Array) {
            const copy = [];
            for (let i = 0, len = obj.length; i < len; i++) {
                copy[i] = this.deepCopy(obj[i]);
            }
            return copy;
        }
        
        // Handle Object
        if (obj instanceof Object) {
            const copy = {};
            for (let attr in obj) {
                if (obj.hasOwnProperty(attr))
                    copy[attr] = this.deepCopy(obj[attr]);
            }
            return copy;
        }
        
        // fallback, should never happen
        console.warn("ObjectUtil.deepCopy");
        return JSON.parse(JSON.stringify(obj));
    }
    
    /**
     * 
     * @param jsonA 
     * @param jsonB 
     * 
     * @returns 
     */
    equals(jsonA: any, jsonB: any): boolean {
        if (!jsonA && !jsonB) {
            // both elements can pass condition but null != NaN (for numbers)
            return jsonA === jsonB; // not sure if this is right response or if we should throw error here
        } else if ((jsonA && jsonB) && (typeof jsonA === "object") && (typeof jsonB === "object") && (jsonA === jsonB)) {
            if (es["isDeveloper"]) {
                es.log.warn("ObjectUtil.equals() has been passed two objects that refer to the same location in memory.", jsonA);
            }
            return true;
        }
        
        if (jsonA === jsonB) {
            return true; // same object or string/boolean/number match.
        } else if (jsonA && jsonB && (typeof jsonA === "object") && (typeof jsonB === "object")) {
            if (jsonA instanceof Array) {
                if (jsonB instanceof Array) { // compare arrays
                    if (jsonA.length === jsonB.length) {
                        for (let i = jsonA.length; i-- > 0;) {
                            if (!this.equals(jsonA[i], jsonB[i])) {
                                return false; // elements in array did not match
                            }
                        }

                        return true; // arrays matched
                    }
                }
            } else if (!(jsonB instanceof Array)) {
                // Dates are objects but have no key-value structure:
                if (jsonA instanceof Date && jsonB instanceof Date) {
                    return jsonA.toJSON() === jsonB.toJSON();
                } else {
                    const keysA = Object.keys(jsonA).sort();
                    const keysB = Object.keys(jsonB).sort();
                    if (this.equals(keysA, keysB)) {
                        for (let k = keysA.length; k-- > 0;) {
                            const key = keysA[k];

                            if (!this.equals(jsonA[key], jsonB[key])) {
                                return false; // elements in objects did not match
                            }
                        }

                        return true; // objects matched
                    }
                }
            }
        }

        return false;
    }
    
    /**
     * Removes object keys that have null or undefined value from object or array of objects...
     */
    removeNullKeys(obj: any) {
        if (obj && typeof obj === "object") {
            const keys = Object.keys(obj);
            for (let i = keys.length; i--; ) {
                const key = keys[i];
                
                if (obj[key] == null) {
                    delete obj[key];
                } else if (typeof obj[key] === "object") {
                    this.removeNullKeys(obj[key]);
                }
            }
        } else if (obj instanceof Array) {
            for (let i = obj.length; i--; ) {
                this.removeNullKeys(obj[i]);
            }
        }
        
        return obj;
    }
}
